import React, { useState, useEffect } from 'react';
import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import InnerLoader from '../../../Components/Common/InnerLoader';
import CreateAnalyticsPageForm from './CreateAnalyticsPageForm';
import { getAllFields } from '../../../actions/promotion/fields';
import { useDispatch } from 'react-redux';
const CreateAnalyticsPage = ({ isFromMenu = false }) => {
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [open, setOpen] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getFields();
  }, []);

  const submitHandler = () => {
    setOpen('');
  };

  const getFields = async () => {
    try {
      const { data } = await getAllFields(
        {
          pageOffset: Math.max(0),
          pageSize: 2000,
        },
        dispatch
      );
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {isFromMenu ? (
        <span
          className=""
          onClick={() => {
            setIsOpenModal(true);
          }}
        >
          <i className="bx bx-plus"></i>
        </span>
      ) : (
        <div className="d-flex flex-row float-end ">
          <Button
            color="primary"
            size="sm"
            onClick={() => {
              console.log('Open config modal');
              setIsOpenModal(true);
            }}
            className="pt-1 pb-1"
          >
            Create Analytics Page
          </Button>
        </div>
      )}

      <Offcanvas
        isOpen={isOpenModal}
        toggle={() => {
          setIsOpenModal(!isOpenModal);
        }}
        id="offcanvasRight"
        direction="end"
        style={{ width: '90vw' }}
      >
        <OffcanvasHeader
          toggle={() => {
            setIsOpenModal(!isOpenModal);
          }}
          id="offcanvasRightLabel"
          className="align-items-start border-bottom"
        >
          Create Analytics Page
        </OffcanvasHeader>
        <OffcanvasBody>
          <CreateAnalyticsPageForm
            closeHandler={() => setOpen('')}
            submitHandler={submitHandler}
          />
          {isLoading ? <InnerLoader /> : null}
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default CreateAnalyticsPage;
